import { render, staticRenderFns } from "./SalidaEdit.vue?vue&type=template&id=a203f2f4&scoped=true&"
import script from "./SalidaEdit.vue?vue&type=script&lang=ts&"
export * from "./SalidaEdit.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "a203f2f4",
  null
  
)

export default component.exports